/* SearchLoading.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _21 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _20 = "._1e0c1ule{display:block}";
const _19 = "._18u0idpf{margin-left:0}";
const _18 = "._otyridpf{margin-bottom:0}";
const _17 = "._2hwxidpf{margin-right:0}";
const _16 = "._19pkidpf{margin-top:0}";
const _15 = "._vwz4f6fq{line-height:18px}";
const _14 = "._k48p1nn1{font-weight:400}";
const _13 = "._ect48q0o{font-family:Charlie Text}";
const _12 = "._1wyboqnp{font-size:.75rem}";
const _11 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _10 = "@media (min-width:64rem){._dm251ule{display:block}}";
const _9 = "._1e0cglyw{display:none}";
const _8 = "._18m915vq{overflow-y:hidden}";
const _7 = "._1reo15vq{overflow-x:hidden}";
const _6 = "._o5721q9c{white-space:nowrap}";
const _5 = "._1bto1l2s{text-overflow:ellipsis}";
import Spinner from '@atlaskit/spinner';
import { BodySmall } from '@atlassian/mpac-primitives';
import { ellipsisCompiled } from '@atlassian/mpac-ui/theme';
import React from 'react';
import { desktopOnly, mobileOnly } from '../../SearchUtils/ResponsiveUtils';
const _4 = "._1tke1mjv{min-height:300px}";
const _3 = "._zulp1eps{gap:var(--ds-space-100)}";
const _2 = "._1yt47ahi{padding:var(--ds-space-250) var(--ds-space-250) var(--ds-space-050) var(--ds-space-300)}";
const _ = "._1e0c1txw{display:flex}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _1yt47ahi _zulp1eps _1tke1mjv", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const baseLabel = {
  color: "var(--ds-text-subtle)",
  fontSize: '0.75rem',
  fontFamily: 'Charlie Text',
  fontWeight: 400,
  lineHeight: '18px',
  margin: 0
};
const LargeLabel = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0cglyw _dm251ule _syaz1k3w _1wyboqnp _ect48q0o _k48p1nn1 _vwz4f6fq _19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  LargeLabel.displayName = 'LargeLabel';
}
const SmallLabel = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_5, _6, _7, _8, _20, _21, _11, _12, _13, _14, _15, _16, _17, _18, _19]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1ule _dm25glyw _syaz1k3w _1wyboqnp _ect48q0o _k48p1nn1 _vwz4f6fq _19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SmallLabel.displayName = 'SmallLabel';
}
export const SearchLoading = _ref4 => {
  let {
    query = 'suggesti'
  } = _ref4;
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": "skeleton-items"
  }, /*#__PURE__*/React.createElement(LargeLabel, null, "Suggestions for \u2018", query, "\u2019"), /*#__PURE__*/React.createElement(SmallLabel, null, "Suggestions"), /*#__PURE__*/React.createElement(Spinner, {
    interactionName: "load",
    size: "small"
  }));
};